import { useEffect } from 'react';
import { AffiliateMetricsCards } from '@/features/analytics/components/affiliate/AffiliateMetricsCards';
import { AffiliateTableSection } from '@/features/analytics/components/affiliate/AffiliateTableSection';
import { useParams } from 'react-router-dom';
import { useBreadcrumbs } from '@/hooks/useBreadcrumbs';
import { useStanRouter } from '@/hooks/useStanRouter';

/**
 * AffiliateAnalyticsPage - Main page for affiliate analytics.
 *
 * Performance optimized:
 * - Each component manages its own data fetching
 * - useStanQuery with keepPreviousData prevents UI jumps
 * - React Query handles caching and deduplication automatically
 */
export default function AffiliateAnalyticsPage() {
    const { pageId } = useParams<{ pageId: string }>();
    useBreadcrumbs([
        { title: 'Analytics', to: '/analytics', id: 'analytics' },
        { title: 'Affiliate Analytics', to: '', id: 'affiliate-analytics', active: true },
    ]);
    const { push } = useStanRouter();

    useEffect(() => {
        if (!pageId) {
            push('/stores');
        }
    }, [pageId, push]);

    if (!pageId) {
        return (
            <div className='flex flex-col gap-8'>
                <h1 className='font-bold'>Affiliate Analytics</h1>
                <p className='text-neutral-main'>Page not found</p>
            </div>
        );
    }
    return (
        <div className='flex flex-col gap-8'>
            <AffiliateMetricsCards pageId={pageId} />
            <AffiliateTableSection pageId={pageId} />
        </div>
    );
}
